export default __webpack_public_path__ + "static/media/logo-round.67aa92bf.svg";